import { CSSProperties, FC, ReactNode } from 'react';

import OverflowFadeText from '../../OverflowFadeText';

interface SiderIconLabelProps {
    color?: CSSProperties['color'];
    gap?: CSSProperties['gap'];
    icon: ReactNode;
    label: ReactNode;
    style?: CSSProperties;
}

/**
 * Keeps left-sider glyphs and labels on the same optical centerline.
 * Icon SVG baseline offsets are intentionally neutralized by the flex shell.
 */
const SiderIconLabel: FC<SiderIconLabelProps> = ({ color, gap = '0.375rem', icon, label, style }) => (
    <span
        style={{
            alignItems: 'center',
            color,
            display: 'inline-flex',
            gap,
            maxWidth: '100%',
            minWidth: 0,
            verticalAlign: 'middle',
            ...style,
        }}
    >
        <span
            style={{
                alignItems: 'center',
                display: 'inline-flex',
                flex: '0 0 auto',
                justifyContent: 'center',
                lineHeight: 0,
            }}
        >
            {icon}
        </span>
        <OverflowFadeText style={{ flex: '1 1 auto', lineHeight: 'inherit' }}>{label}</OverflowFadeText>
    </span>
);

export default SiderIconLabel;
